
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function About() {
  const stats = [
    { number: '50K+', label: 'عميل سعيد' },
    { number: '1000+', label: 'منتج متنوع' },
    { number: '15+', label: 'دولة نخدمها' },
    { number: '24/7', label: 'دعم فني' }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'الجودة والثقة',
      description: 'نضمن لك أعلى معايير الجودة في جميع منتجاتنا مع ضمان الاسترجاع'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'خدمة العملاء',
      description: 'فريق دعم متخصص متاح على مدار الساعة لمساعدتك في أي استفسار'
    },
    {
      icon: 'ri-rocket-line',
      title: 'الشحن السريع',
      description: 'نوفر خدمة شحن سريعة وآمنة لجميع الطلبات في وقت قياسي'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'أسعار تنافسية',
      description: 'نقدم أفضل الأسعار في السوق مع عروض وخصومات مستمرة'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              من نحن
            </h1>
            <p className="text-xl max-w-3xl mx-auto leading-relaxed text-gray-400">
              نحن متجر إلكتروني رائد في مجال التجارة الإلكترونية، نسعى لتوفير أفضل تجربة تسوق عبر الإنترنت من خلال تقديم منتجات عالية الجودة بأسعار تنافسية وخدمة عملاء متميزة
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#D4A84B' }}>
                  {stat.number}
                </div>
                <div className="font-medium text-gray-400">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mb-20">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  قصتنا
                </h2>
                <div className="space-y-4 leading-relaxed text-gray-400">
                  <p>
                    بدأت رحلتنا في عام 2020 بهدف واضح: تقديم تجربة تسوق إلكترونية استثنائية للعملاء في المنطقة. منذ ذلك الحين، نمونا لنصبح واحداً من أكثر المتاجر الإلكترونية موثوقية في السوق.
                  </p>
                  <p>
                    نؤمن بأن التسوق عبر الإنترنت يجب أن يكون سهلاً وممتعاً وآمناً. لذلك، نعمل باستمرار على تحسين خدماتنا وتوسيع مجموعة منتجاتنا لتلبية احتياجات عملائنا المتنوعة.
                  </p>
                  <p>
                    فريقنا المتخصص يعمل على مدار الساعة لضمان حصولك على أفضل تجربة تسوق ممكنة، من اختيار المنتج حتى وصوله إلى باب منزلك.
                  </p>
                </div>
              </div>
              <div className="relative aspect-[4/3] w-full h-full rounded-2xl overflow-hidden shadow-xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/3b71d1a9af2619b69148a09bc44bd945.jpg"
                  alt="فريق العمل"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              قيمنا ومبادئنا
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div 
                  key={index}
                  className="rounded-2xl p-8 text-center transition-all duration-300 hover:transform hover:scale-105"
                  style={{ backgroundColor: '#1B2D3E', borderTop: '4px solid #D4A84B' }}
                >
                  <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6" style={{ backgroundColor: 'rgba(212, 168, 75, 0.15)' }}>
                    <i className={`${value.icon} text-3xl`} style={{ color: '#D4A84B' }}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                    {value.title}
                  </h3>
                  <p className="leading-relaxed text-gray-400">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
